import { render, staticRenderFns } from "./PackageQuotePost.vue?vue&type=template&id=8166afa4&"
import script from "./PackageQuotePost.vue?vue&type=script&lang=js&"
export * from "./PackageQuotePost.vue?vue&type=script&lang=js&"
import style0 from "./PackageQuotePost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PackageQuotePost.vue"
export default component.exports